import { render } from "./section_field.vue?vue&type=template&id=1226eb54&lang=pug"
import script from "./section_field.vue?vue&type=script&lang=js"
export * from "./section_field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__